export default __webpack_public_path__ + "static/media/topic1200bg.b47ea573.png";